export enum Device {
    DESKTOP = 1,
    MOBILE = 2,
    TABLET = 3,
    APP = 4
}